import { createFileRoute } from '@tanstack/react-router';
import { object, optional, parse, picklist } from 'valibot';

import { ensureRouteAccess } from '@/lib/auth/guards';

export const ENTITY_DETAIL_TABS = [
  'profile',
  'programs',
  'users',
  'providers',
  'clinical',
] as const;

export type EntityDetailTab = (typeof ENTITY_DETAIL_TABS)[number];

const searchSchema = object({
  tab: optional(picklist(ENTITY_DETAIL_TABS)),
});

export const validateEntityDetailSearch = (search: Record<string, unknown>) =>
  parse(searchSchema, search);

export const Route = createFileRoute('/(authenticated)/entities/$entityId')({
  validateSearch: validateEntityDetailSearch,
  beforeLoad: ensureRouteAccess('/entities'),
});
